import { Mobile, Navigation, Carousel_CoreInit, Scrollbar } from './core'
import MainMenu from './modules/main-menu'
import Shapes from './modules/shape'
import GallerySlider from './modules/gallery-slider'
import Slideshow from './modules/slideshow'
import Locator from './modules/locator'
import Escalade from './modules/escalade'
import Popup from './modules/popup'
import CookieBanner from './modules/cookie-banner'
import Vh from './modules/vh'
import VimeoPlayer from '@vimeo/player';
import './plugins/select-filters'
import './plugins/latest-news'
import './plugins/info-btn'
import './plugins/contact-map'
import './plugins/characters'
import './plugins/parallax'
import './plugins/embed-container'

let navigation, firstLoad = true
const mobileChecker = new Mobile()

/* On page load */
$(window).on('page_load', function(event, loadedContent) {
  $.mlmi = {
    mobile: new Mobile(768),
  }

  $('.carousel--style--shape-slider').each(function() {
    $(this).clone().insertAfter($(this)).addClass('carousel--style--shape-slider--mobile')
    $(this).addClass('carousel--style--shape-slider--desktop')
  })

  Carousel_CoreInit([
    {
      classSelector: 'carousel--style--default',
      swiperOptions: {
        loopAdditionalSlides : 4,
      },
    },
    {
      classSelector: 'carousel--postitem__blog_post',
      swiperOptions: {
        loopAdditionalSlides : 4,
      },
    },
    {
      classSelector: 'carousel--style--shape-slider--desktop',
      swiperOptions: {
        loop: true,
        fadeEffect: {
          crossFade: true
        },
        virtualTranslate: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
        },
        speed: 500,
        effect: "fade",
      },
    },
    {
      classSelector: 'carousel--style--shape-slider--mobile',
      swiperOptions: {
        loop: true,
        loopAdditionalSlides : 4,
      },
    },
  ])

  /* App classes */
  $('body, head').attr('class', $('.app').data('view'))
  $('html, body').scrollTop(0)

  /* Loaded content */
  if (loadedContent != undefined) {
    let response = $('<html>').html(loadedContent);
    if (response.find('.home-popup').length > 0) {
      $('.app').after(response.find('.home-popup'))
    }
  }

  /* Prevent empty anchor clicks */
  $('a[href="#"]').on('click', function() {
    return false
  })

  /* Fancybox using link class */
  $('a.fancybox').attr('data-fancybox', 'page').fancybox({
    hash: false,
    buttons: ['close'],
  })

  /* Smooth scrolling */
  $('a[href^="#"]').each(function() {
    if ($(this).attr('href').length > 1 && $($(this).attr('href')).length > 0) {
      $(this).data('preventTransition', 1)
      $(this).on('click', function() {
        let target = $($(this).attr('href')).offset().top,
        distance = Math.abs(target - $(document).scrollTop())
        $('html, body').animate({'scrollTop' : target}, 450 + distance / 5, 'swing')
        return false
      })
    }
  })

  /* Prevent transition on translation link */
  $('.lang-switcher a').data('preventTransition', 1)

  /* Make sure vh works on ios */
  Vh.init()

  /* Main Menu */
  MainMenu.init()

  /* Floating shape */
  Shapes.init()

  /* Gallery slider */
  GallerySlider.init()

  /* Slideshow */
  Slideshow.init(mobileChecker)

  /* Locator */
  Locator.init()

  /* Escalade */
  Escalade.init()

  /* Popup */
  Popup.init()

  /* Cookie banner */
  CookieBanner.init()

  /* Select filters */
  $('.map-chrome__top-bar').SelectFilters()
  $('.map-chrome__sub-bar[data-parent="camping-sur-les-iles"]').SelectFilters()
  $('.map-chrome__sub-bar[data-parent="activites"]').SelectFilters()
  $('.escalade-chrome__top-bar').SelectFilters()

  /* Latest news panel */
  $('.latest-news').each(function() {
    $(this).LatestNews(navigation, mobileChecker)
  })

  /* Fade-in elements */
  $('.fadein, .faq__item').each(function() {
    $(this).FadeIn()
  })

  /* Info buttons */
  $('.info-btn').each(function() {
    $(this).InfoButton()
  })

  /* Contact map */
  $('.contact-map').each(function() {
    $(this).ContactMap()
  })

  /* Textarea */
  $('.wpcf7 textarea[maxlength]').each(function() {
    $(this).Characters()
  })

  /* Homepage */
  $('.--home-header .grid--style--overlay-bottom .card-overlay-bottom__image').each(function() {
    $(this).parallax(.5, 'desktop')
  })

  $('.--home-header .grid--style--overlay-top .grid__item').each(function() {
    $(this).parallax(.35, 'desktop')
  })

  $('.--home-header .card-overlay-bottom').each(function() {
    setTimeout(function(el) {
      el.css('opacity', 1)
    }, 1000, $(this));
  })

  $('.--home-header .card-overlay-top').each(function() {
    setTimeout(function(el) {
      el.css('opacity', 1)
    }, 2000, $(this));
  })

  $('.grid--no-carousel-sm.grid--no-carousel-md').each(function() {
    $(this).closest('.col').prev('.col').find('.grid-heading-item').addClass('no-carousel')
  })

  /* Position last minute row */
  $('.text-row.last-minute').each(function() {
    let lastMinuteRow = $(this), lastMinuteGrid = lastMinuteRow.find('.grid')
    function placeLastMinuteRow() {
      let parallaxWidth = '', targetWidth = '', windowWidth = $(window).width()
      if (!mobileChecker.isMobile) {
        parallaxWidth = 0
        $('.parallax-wrapper').each(function() {
          parallaxWidth += $(this).outerWidth(false)
        })
        parallaxWidth = Math.round(windowWidth - parallaxWidth)
        if (parallaxWidth > 114) {
          parallaxWidth = 114
        }
        parallaxWidth = parallaxWidth + 'px'
        targetWidth = Math.ceil(windowWidth - lastMinuteRow.find('.grid').offset().left) + 'px'
      }
      lastMinuteRow.css({
        marginTop: parallaxWidth,
      })
      lastMinuteGrid.css({
        width: targetWidth,
      })
    }
    $(window).on('resize orientationchange load', placeLastMinuteRow)
    placeLastMinuteRow()
  })

  /* Footer */
  $('.footer').each(function() {
    $(this).css('--min-height', $(this).find('.footer__newsletter').height() + 'px');
  })

  /* Contact form */
  if (!firstLoad) {
    $('div.wpcf7 > form').each( function() {
      var $form = $(this)
      wpcf7.init($form[0])
    })
  }

  /* Checkbox */
  $('.email-field').each(function() {
    let self = $(this)
    self.find('label[for="en"]').on('click', function(e) {
      e.preventDefault()
      self.find('input#en').prop('checked', true)
    })
    self.find('label[for="fr"]').on('click', function(e) {
      e.preventDefault()
      self.find('input#fr').prop('checked', true)
    })
  })

  /*  Blog Post Categories */
  $('.blog-post-categories__button').on('click', function() {
    if ($(this).closest('.blog-post-categories').attr('aria-expanded') == "true") {
      $(this).closest('.blog-post-categories').attr('aria-expanded', false);
    } else {
      $(this).closest('.blog-post-categories').attr('aria-expanded', true);
    }
  })

  /* Copy page URL */
  $('.post-share__button').on('click', function() {
    if ($(this).closest('.post-share').attr('aria-expanded') == "true") {
      $(this).closest('.post-share').attr('aria-expanded', false);
    } else {
      $(this).closest('.post-share').attr('aria-expanded', true);
    }
  })
  let copiedTimeout = undefined
  $('.post-share__action--copy-link').on('click', function() {
    let self = $(this)
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('.copied').addClass('visible').text(poissonblanc_values.COPIED_LINK)
    clearTimeout(copiedTimeout)
    copiedTimeout = setTimeout(function() {
      self.find('.copied').removeClass('visible')
    }, 3200)
  })

  /* Video row */
  let isScaled = false, isPushed = false, player = undefined
  $('.row.video-row').each(function() {
    let self = $(this),
    videoRow = $(this).find('.video-row')
    if (self.find('iframe').length > 0) {
      player = new VimeoPlayer(self.find('iframe').get(0));
    }

    if (self.find('.video-row__media.mobile-only').length == 0) {
      self.addClass('--mobile-cover')
    }

    if (self.find('.video-row__media.desktop-only').length == 0) {
      self.addClass('--desktop-cover')
    }

    let fixedContent_video = videoRow.FixedContent({
      topBlocker: null,
      limitFromTop: 0,
      bottomBlocker: $('.video-row__end'),
      mobile: true,
      fixedClass: '--scaled',
      pushedClass: '--pushed',
    })

    $(window).ScrollEvents().add(function() {
      if (!isPushed && videoRow.hasClass('--pushed')) {
        isPushed = true
        isScaled = false
        videoRow.addClass('--pushed-go')
        setTimeout($('.embed-container').EmbedContainer().calculate_ratio, 500)
      } else if (!isPushed && videoRow.hasClass('--scaled') && !isScaled) {
        isScaled = true
        isPushed = false
        videoRow.removeClass('--pushed-go').addClass('--scaled-go')
      } else {
        if (!videoRow.hasClass('--pushed') && videoRow.hasClass('--pushed-go')) {
          isPushed = false
          videoRow.removeClass('--pushed-go')
        }
        if (!videoRow.hasClass('--scaled') && videoRow.hasClass('--scaled-go')) {
          isScaled = false
          videoRow.removeClass('--scaled-go')
          setTimeout($('.embed-container').EmbedContainer().calculate_ratio, 500)
        }
      }
    })

    if (self.find('iframe').length > 0 && player != undefined) {
      player.pause();
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          var attributeValue = $(mutation.target).prop(mutation.attributeName);
          if (attributeValue.search('--scaled') > -1 && attributeValue.search('--pushed') == -1) {
            player.play();
          } else {
            player.pause();
          }
        });
      });

      observer.observe($(this).find('.video-row')[0], {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  })

  $('.embed-container').each(function() {
    $(this).EmbedContainer()
  })

  /* Make videos look like images */
  $('.video-loop').each(function() {
    let self = $(this)
    let video = $(this).find('video')
    if (video.data('loaded')) {
      setTimeout(function() {
        picture(video.get(0))
        video.get(0).play()
      }, 60)
    } else {
      video.on('canplaythrough', function() {
        picture(video.get(0))
        video.get(0).play()
      })
    }
  })

  /* First load flag */
  firstLoad = false
})

/* On page exit */
$(window).on('page_exit', function() {
  /* Unload images */
  $('.app').find('img').attr('src', '').remove()

  /* Close mobile menu */
  if (mobileChecker.isMobile) {
    $('.burger--close').click()
  }

  /* Kill active objects */
  GallerySlider.kill()
  Slideshow.kill()
  Shapes.kill()
  Popup.kill()
})

/* Navigation */
$(function () {
  navigation = new Navigation({
    init: false,
  })
  navigation.init()

  /* Concours */
  $(document).on('wpcf7mailsent', function(){
    $('.wpcf7').css('opacity', 0)
    setTimeout(function() {
      $('.wpcf7').height($('.wpcf7').height()).empty().append($('#concours-confirmation .text-content').addClass('pr-md-5 concours-confirmation'))
      $('.wpcf7').css('opacity', 1)
      let target = $('.wpcf7').offset().top - (mobileChecker.isMobile ? 32 : 52),
      distance = Math.abs(target - $(document).scrollTop())
      $('html, body').animate({'scrollTop' : target}, 450 + distance / 5, 'swing')
    }, 350)
  })
})

$(window).on('page_load resize orientationchange load', function(){
  $('.post-share__dropdown').each(function() {
    $(this).css('--max-height', $(this).find('.post-share__actions').height() + 'px');
  })

  $('.blog-post-categories__wrapper').each(function() {
    $(this).css('--max-height', $(this).find('.blog-post-categories__options').height() + 'px');
  })
});
